export const COLLECTIONS = {
  experiences: "experiences",
  projects: "projects",
  skills: "skills",
  about: "about",
};

export const DOCUMENTS = {
  techSkills: "tech-skills",
  personalProjects: "personal-projects",
  techExperiences: "tech-experiences",
  aboutItems: "about-items",
};
